module.exports = __webpack_public_path__ + "img/exame.d6b449d6.webp";